"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportAudit = void 0;
const endpoint_1 = require("api/endpoint");
const permissions_1 = require("shared/permissions");
exports.exportAudit = endpoint_1.createEndpoint()({
    permissions: permissions_1.PERMISSIONS.DISPENSIFY_ORDER_READ,
    method: 'post',
    path: 'google/exportAudit',
});



//////////////////
// WEBPACK FOOTER
// ./src/api/google/google-client.ts
// module id = 985
// module chunks = 0 1 2